<template>
  <div id="tramiteNuevo">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12 >
          <h4 class="grey--text text--darken-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon small color="primary">drag_indicator</v-icon>
              </template>
              <span>Menú Principal</span>
            </v-tooltip>Trámite / Filtro
          </h4>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
      <v-card class="elevation-0">
        <v-card-title class="lighten-3">
          <span><b>Tipo de Trámites:</b> {{ tramites }}</span>
          <v-spacer></v-spacer>
          <v-btn outline color="primary" small @click="showInfo = !showInfo">{{ showInfo?'Ocultar': 'Mostrar' }} Datos</v-btn>
        </v-card-title>
        <v-card-text v-if="showInfo==true">
          <v-data-table
            :headers="headers"
            :loading="loading"
            :items="tarea.evaluacion"
            class="elevation-1"
            hide-actions
            v-cloak
          >
            <template v-slot:items="props">
              <td>{{ props.index + 1 }}</td>
              <td>
                <span v-html="props.item.pregunta"></span>
              </td>
              <td>
                {{ props.item.si==true?'X':'' }}
              </td>
              <td>
                {{ props.item.no==true?'X':'' }}
              </td>
              <td>
                {{ props.item.observacion }}
              </td>
            </template>
          </v-data-table>
          <v-btn color="teal lighten-2" dark small :href="serve + 'uploads/cctp/' + tarea.informe_viabilidad" target="_blank">
            <v-icon>description</v-icon> Informe de viabilidad
          </v-btn>
        </v-card-text>
      </v-card>
      <br>
      <v-card>
        <v-card-title class="headline  lighten-3">
          <span class="headline">Filtro Nacional</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-form ref="form_filtro">
          <v-data-table
            :headers="headers"
            :loading="loading"
            :items="requisitos"
            class="elevation-1"
            hide-actions
            v-cloak
          >
            <template v-slot:items="props">
              <td>{{ props.index + 1 }}</td>
              <td>
                <span v-html="props.item.pregunta"></span>
              </td>
              <td>
                <v-checkbox
                  v-if="props.item.respuesta"
                  v-model="props.item.si"
                  @change="props.item.no=false"
                  hide-details
                ></v-checkbox>
              </td>
              <td>
                <v-checkbox
                  v-show="props.item.respuesta"
                  v-model="props.item.no"
                  color="red"
                  @change="props.item.si=false"
                  hide-details
                ></v-checkbox>
              </td>
              <td>
                <v-text-field
                  v-if="props.item.respuesta"
                  v-model="props.item.observacion"
                  class="pa-0"
                ></v-text-field>
              </td>
            </template>
          </v-data-table>
          <v-card-text>
            <v-switch
              v-model="procede"
              :label="'¿Procede el trámite?: ' +(procede==true?'Si':'No')"
              @change="clearValue(procede)"
            ></v-switch>
            <v-layout v-if="procede" transition="slide-x-transition">
              <v-flex xs12 class="my-0">
                <v-checkbox
                  v-model="pago_arancel"
                  :label="'Autorizar Pago de Arancel: ' +(pago_arancel==true?'Si':'No')"
                  :rules="[v => !!v || 'Marque la opción']"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout v-else transition="slide-x-transition">
              <v-flex xs12 class="my-0">
                <v-textarea
                  label="Observación"
                  v-model="observacion"
                  :rules="[v => !!v || 'El campo es requerido']"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-form>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click="confirmTramite">
            Guardar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="cdialog" persistent max-width="300px">
        <v-card>
          <v-card-title class="headline grey lighten-3">
            <span class="headline">Alerta</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="text-xs-center">
            <p :class="color_txt + '--text text--darken-2 subheading'">
              {{ mensaje }}
            </p>
            <v-btn
              v-if="hide_accept == false"
              :loading="loadingPrint"
              outline
              color="primary"
              @click="filtroNacional"
              class="mt-3"
            >
              Imprimir Filtro
            </v-btn>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :loading="loadingBtnSend" v-if="hide_accept" color="success darken-1" flat @click.native="sendTramite">
              Aceptar
            </v-btn>
            <v-btn color="blue darken-1" flat @click.native="closeDialog">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar
        v-model="snack.state"
        top
        right
        :timeout="2800"
        :color="snack.color"
        :multi-line="snack.mode === 'multi-line'"
      >
        {{ snack.text }}
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Service from "../services/general";
import axios from "axios";
export default {
  name: "filtro-departamental",
  data: () => ({
    showInfo: false,
    headers: [
      { text: 'Nro', align: 'left', sortable: false, width: '6%' },
      { text: 'Requisitos ', sortable: false, width: '46%' },
      { text: 'Si', sortable: false, width: '6%' },
      { text: 'No', sortable: false, width: '6%' },
      { text: 'Observaciones', sortable: false, width: '36%' }
    ],
    loading: false,
    loadingBtnSend: false,
    loadingPrint: false,
    cdialog: false,
    hide_accept: false,
    color_txt: '',
    mensaje: '',
    dparams: {},
    procede: true,
    pago_arancel: true,
    observacion: '',
    requisitos: [],
    tipo_tramite: [],
    institucioneducativa_id: '',
    tramites: '',
    tarea: '',
    serve: '',
    snack: {
      state: false,
      color: "success",
      mode: "",
      timeout: 3000,
      text: ""
    }
  }),
  created() {
    if (Service.getTramiteId() == null) {
      this.$router.push('/tramite/recibido');
    } else {
      this.getDatos();
    }
  },
  mounted() {
    this.serve = Service.getServe();
    this.dparams = Service.getParams();
    if (this.dparams && this.dparams.roluser != Service.rol().nacional) {
      this.$router.push({name: 'principal'});
    }
    this.requisitos = [
      { pregunta: '<b>NOTA DE SOLICITUD</b>.- Dirigido(a) a la Ministra o Ministro de Educación.', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>a</b>.	Solicitud de apertura/ratificación/ampliación de cursos de capacitación, de Sede Central y/o Subsede.', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>b</b>.	Identificar naturaleza jurídica y Razón Social del Centro de Capacitación Técnica Privado y Sigla (si corresponde).', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>c</b>.	Identificación de la persona responsable del Centro de Capacitación Privado (Propietaria/o, socios y/o Representante Legal)', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>d</b>.	Especificar la denominación de los cursos, carga horaria y tiempo de capacitación. ', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>e</b>.	Domicilio del Centro de Capacitación, teléfono, correo electrónico.', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>DOCUMENTOS LEGALES</b>', respuesta: false, si: false, no: false, observacion: '' },
      { pregunta: '<b>a</b>.	Fotocopia de Cédula de Identidad de la propietaria o propietario y/o del representante legal (si corresponde).', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>b</b>.	Original o fotocopia legalizada del Poder otorgado ante Notaría de Fe Pública a favor del representante legal.', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>c</b>.	Fotocopia legalizada de Testimonio de Constitución o Estatuto de Constitución para personas jurídicas (si corresponde).', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>d</b>.	Certificado de Inscripción en el Padrón Nacional de Contribuyentes (NIT), con actividad principal en Educación.', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>e</b>.	Original o fotocopia legalizada de Certificado de Registro de Comercio otorgado por FUNDEMPRESA.', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>f</b>.	Folio Real (Propietario) y/o Formulario de información rápida de Derechos Reales (Inquilino) del bien inmueble donde se desarrollaran los cursos cortos de capacitación técnica.', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>g</b>.	Original o fotocopia legalizada de Contrato de alquiler o anticresis, por el tiempo de 5 años elevado a instrumento público.', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>h</b>.	Planos de infraestructuras destinada al Centro de Capacitación Técnica. (Espacios: administración, de capacitación, de servicio y complementarias), debidamente firmado por Arquitecto.', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>i</b>. Formulario de Declaración Jurada CCTP, según corresponda, debidamente llenado.', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>RECURSOS HUMANOS</b>', respuesta: false, si: false, no: false, observacion: '' },
      { pregunta: '<b>a</b>. Estructura institucional.', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>b</b>. Directora o director general.', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>c</b>. Responsable administrativo – financiero.', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>d</b>. Facilitadoras o facilitadores.', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>e</b>. Personal de apoyo y de servicio.', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>f</b>. Contrato laboral.', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>g</b>. Reglamento interno (directivos, facilitadores, participantes y administrativos).', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>INFRAESTRUCTURA Y EQUIPAMIENTO</b>', respuesta: false, si: false, no: false, observacion: '' },
      { pregunta: '<b>a</b>. Infraestructura.', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>b</b>. Equipamiento.', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>c</b>. Materiales didácticos.', respuesta: true, si: false, no: false, observacion: '' },
      { pregunta: '<b>d</b>. Formulario de declaración jurada.', respuesta: true, si: false, no: false, observacion: '' }
    ];
  },
  methods: {
    getDatos() {
      axios
        .get(Service.getBase() + "tramite/tarea/2/" + Service.getTramiteId(), Service.getHeader())
        .then(response => {
          if (response.data.datos != '') {
            this.tarea = JSON.parse(response.data.datos);
            this.institucioneducativa_id = this.tarea.institucioneducativa_id;
            this.tipo_tramite = this.tarea.tipo_tramite;
            var cantidad_tramites = (this.tarea.tipo_tramite.length-1);
            for (var key in this.tarea.tipo_tramite) {
              let tramite_nombre = '';
              switch (this.tarea.tipo_tramite[key]) {
                case 2:
                  tramite_nombre = 'Ratificación';
                  break;
                case 3:
                  tramite_nombre = 'Ampliación';
                  break;
                case 4:
                  tramite_nombre = 'Cambio de Razón Social';
                  break;
                case 5:
                  tramite_nombre = 'Cambio de Domicilio';
                  break;
                case 6:
                  tramite_nombre = 'Cambio de derecho Propietario';
                  break;
                case 7:
                  tramite_nombre = 'Cierre del Centro de Capacitación';
                  break;
                default:
                  tramite_nombre = 'Apertura';
                  break;
              }
              this.tramites += tramite_nombre+(key < cantidad_tramites?', ':'');
            }
          }
        })
        .catch(error => {
          console.error("Error al cargar registros", error);
        });
    },
    confirmTramite() {
      let index = this.requisitos.findIndex(x => (x.si === true || x.no === true));
      if (index == -1) {
        this.toast('warning', 'Debe marcar las preguntas en base a los documentos presentados.');
      } else {
        this.color_txt = 'grey';
        this.mensaje = '¿Esta seguro(a) de guardar el trámite con la información ingresada?';
        this.loadingBtnSend = false;
        this.hide_accept = true;
        if (this.$refs.form_filtro.validate()) {
          this.cdialog = true;
        }
      }
    },
    sendTramite() {
      this.loadingBtnSend = true;
      this.dparams.tipo_tramite = this.tipo_tramite;
      this.dparams.ie_id = this.institucioneducativa_id;
      this.dparams.tramite_id = Service.getTramiteId();
      var datos = { params: JSON.stringify(this.dparams), evaluacion: JSON.stringify(this.requisitos), procede: this.procede, pago_arancel: this.pago_arancel, observacion: this.observacion };
      axios
        .post(Service.getBase() + 'verifica/nacional', datos, Service.getHeader())
        .then(response => {
          this.loadingBtnSend = false;
          if (response.data.estado == 200) {
            this.color_txt = 'success';
            this.$refs.form_filtro.reset();
            this.procede = false;
            this.hide_accept = false;
            this.condicion_ruta = response.data.condicion;
          } else {
            this.color_txt = 'error';
            this.hide_accept = true;
          }
          this.mensaje = response.data.msg;
        })
        .catch(error => {
          this.loadingBtnSend = false;
          this.color_txt = 'error';
          this.hide_accept = true;
          this.mensaje = "No se pudo registrar el trámite";
          console.error("Error al guardar", error);
        });
    },
    clearValue() {
      this.pago_arancel = true;
      this.observacion = '';
    },
    closeDialog() {
      if (this.hide_accept == false) {
        if (this.condicion_ruta == 'NO') {
          Service.removeTramiteId();
          this.$router.push({name: 'tramite/recibido'});
        } else {
          this.$router.push({name: 'registro'});
        }
      }
      this.cdialog = false;
    },
    filtroNacional() {
      this.loadingPrint = true;
      let orden = 4;
      if (this.tipo_tramite.includes(1)) {
        orden = 3;
      }//Service.getTramiteId() //1671386
      axios
        .get(Service.getBase() + "tramite/imprime/"+orden+"/"+Service.getTramiteId(), Service.getHeader())
        .then(response => {
          this.loadingPrint = false;
          var requisitos = response.data.evaluacion;
          var myData = [];
          //{text: 'N°', style: 'tableHeader', alignment: 'center', fillColor: '#e0e3e5', fontSize: 9.5}, 
          myData.push([{text: 'REQUISITOS', style: 'tableHeader'}, {text: 'SI', style: 'tableHeader'}, {text: 'NO', style: 'tableHeader'}, {text: 'OBSERVACIONES', style: 'tableHeader'}]);
          for (const key in requisitos) {
            if (requisitos[key].respuesta == true) {
              //{text: 'N°', alignment: 'center', fontSize: 9.5}, 
              myData.push([{text: requisitos[key].pregunta.replace(/<b>|<|b>|\/|"/g, "")}, {text: (requisitos[key].si==true || requisitos[key].si=='true')?'x':'', alignment: 'center'}, {text: (requisitos[key].no==true || requisitos[key].no=='true')?'x':'', alignment: 'center'}, {text: requisitos[key].observacion}]);
            } else {
              myData.push([{text: requisitos[key].pregunta.replace(/<b>|<|b>|\/|"/g, ""), colSpan: 4}, {}, {}, {}]);
            }
          }

          var docDefinition = {
            pageMargins: Service.pdfSetting().pMargin,
            pageSize: Service.pdfSetting().pSize,
            pageOrientation: Service.pdfSetting().pOrientation,
            defaultStyle : Service.pdfSetting().defStyle,
            header: Service.pdfSetting().myheader('FILTRO NACIONAL'),
            footer: Service.pdfSetting().myfooter,
            styles: Service.pdfSetting().mystyle,
            content: [
              {
                columns: [
                  {
                    width: "53.5%",
                    text: "FORMULARIO DE CUMPLIMIENTO DE REQUISITOS PARA TRÁMITES:",
                    bold : true,
                    margin: [0, 2, 0, 2],
                  },
                  {
                    width: "47.5%",
                    text: response.data.tipo_tramite,
                    margin: [0, 2, 0, 2],
                  }
                ]
              },
              {
                columns: [
                  {
                    width: "15%",
                    text: "Nombre del CCTP.:",
                    bold : true,
                    margin: [0, 2, 0, 2],
                  },
                  {
                    width: "48%",
                    text: response.data.institucioneducativa,
                    margin: [0, 2, 0, 2],
                  },
                  {
                    width: "12%",
                    text: "Lugar y Fecha:",
                    bold : true,
                    margin: [0, 2, 0, 2],
                  },
                  {
                    width: "25%",
                    text: response.data.lugar_fecha,
                    margin: [0, 2, 0, 2],
                  }
                ]
              },
              {
                columns: [
                  {
                    width: "12%",
                    text: "Departamento:",
                    bold : true,
                    margin: [0, 2, 0, 12],
                  },
                  {
                    width: "88%",
                    text: response.data.departamento,
                    margin: [0, 2, 0, 12],
                  }
                ]
              },
              {
                style: 'tableExample',
                table: {
                  headerRows: 1,
                  widths: ['55%','5%','5%','35%'],
                  body: myData
                }
              },
              {
                stack: [
                  { canvas: [{ type: 'line', x1: 340, y1: 50, x2: 212, y2: 50 }] },
                  { text: 'Nombre y firma del revisor', bold : true, alignment: 'center', margin: [0, 4, 0, 0]},
                ]
              }
            ]
          };
          pdfMake.createPdf(docDefinition).open();
          // pdfMake.createPdf(docDefinition).download("FiltroNacional.pdf");
        })
        .catch(error => {
          console.error("Error al cargar registros", error);
        });
    },
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    },
  }
};
</script>